'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var messageformatParser = require('@louischan-oursky/messageformat-parser');
var React = require('react');
var pluralFuncByLanguage = _interopDefault(require('make-plural'));

function parse(source) {
    var tokens = messageformatParser.parse(source, { strict: true });
    return tokens;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function getComponent(key, components) {
    var c = components[key];
    if (c != null) {
        return c;
    }
    var firstChar = key.slice(0, 1);
    if (firstChar.toLowerCase() === firstChar) {
        // Assume it is HTML tag name.
        return key;
    }
    throw new Error("expected component \"" + key + "\" to exist");
}
function getValue(key, values) {
    if (values == null) {
        throw new Error("expected \"" + key + "\" to exist but values is not provided");
    }
    if (!values.hasOwnProperty(key)) {
        throw new Error("expected \"" + key + "\" to exist");
    }
    var value = values[key];
    return value;
}
function getNumber(key, values) {
    var value = getValue(key, values);
    if (typeof value !== "number") {
        throw new Error("expected \"" + key + "\" to be a number");
    }
    return value;
}
function getString(key, values) {
    var value = getValue(key, values);
    if (typeof value !== "string") {
        throw new Error("expected \"" + key + "\" to be a string");
    }
    return value;
}
function evaluateReactDirective(reactDirective, language, values, components, currentValue) {
    var e_1, _a;
    var arg = reactDirective.arg, cases = reactDirective.props;
    var component = getComponent(arg, components);
    var props = {};
    try {
        for (var cases_1 = __values(cases), cases_1_1 = cases_1.next(); !cases_1_1.done; cases_1_1 = cases_1.next()) {
            var c = cases_1_1.value;
            var key = c.key, tokens = c.tokens;
            props[key] = evaluateToInternalValue(tokens, language, values, components, currentValue);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (cases_1_1 && !cases_1_1.done && (_a = cases_1.return)) _a.call(cases_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        __kind: "react",
        type: component,
        props: props,
    };
}
function resolveSelectCase(select, values) {
    var arg = select.arg, cases = select.cases;
    var value = getString(arg, values);
    var targetIndex;
    var otherIndex;
    for (var i = 0; i < cases.length; ++i) {
        var c = cases[i];
        if (c.key === "other") {
            otherIndex = i;
        }
        if (c.key === value) {
            targetIndex = i;
        }
    }
    if (otherIndex === undefined) {
        throw new Error("expected other case");
    }
    if (targetIndex !== undefined) {
        return cases[targetIndex];
    }
    return cases[otherIndex];
}
function resolvePluralFunc(language) {
    var func = pluralFuncByLanguage[language];
    if (func == null) {
        throw new Error("unsupported language: " + language);
    }
    return func;
}
function resolvePluralCase(pluralOrSelectOrdinal, language, values) {
    var type = pluralOrSelectOrdinal.type, arg = pluralOrSelectOrdinal.arg, offsetString = pluralOrSelectOrdinal.offset, cases = pluralOrSelectOrdinal.cases;
    var offset = parseInt(offsetString, 10);
    if (isNaN(offset)) {
        throw new Error("invalid offset");
    }
    var ordinal = type === "selectordinal";
    var pluralFunc = resolvePluralFunc(language);
    var rawValue = getNumber(arg, values);
    var offsetValue = rawValue - offset;
    var pluralRule = pluralFunc(offsetValue, ordinal);
    var valueAsString = String(rawValue);
    var targetIndex;
    var otherIndex;
    for (var i = 0; i < cases.length; ++i) {
        var c = cases[i];
        if (c.key === "other") {
            otherIndex = i;
        }
        if (targetIndex === undefined) {
            if (c.key === valueAsString) {
                targetIndex = i;
            }
            if (c.key === pluralRule) {
                targetIndex = i;
            }
        }
    }
    if (otherIndex === undefined) {
        throw new Error("expected other case");
    }
    if (targetIndex !== undefined) {
        return {
            currentValue: offsetValue,
            pluralCase: cases[targetIndex],
        };
    }
    return {
        currentValue: offsetValue,
        pluralCase: cases[otherIndex],
    };
}
function evaluateToInternalValue(tokens, language, values, components, currentValue) {
    var e_2, _a;
    var output = [];
    try {
        for (var tokens_1 = __values(tokens), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
            var token = tokens_1_1.value;
            if (typeof token === "string") {
                output.push(token);
            }
            else {
                switch (token.type) {
                    case "argument": {
                        var value = getValue(token.arg, values);
                        output.push(value);
                        break;
                    }
                    case "plural": {
                        var result = resolvePluralCase(token, language, values);
                        var nestedTokens = evaluateToInternalValue(result.pluralCase.tokens, language, values, components, result.currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "selectordinal": {
                        var result = resolvePluralCase(token, language, values);
                        var nestedTokens = evaluateToInternalValue(result.pluralCase.tokens, language, values, components, result.currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "react": {
                        var result = evaluateReactDirective(token, language, values, components, currentValue);
                        output.push(result);
                        break;
                    }
                    case "select": {
                        var selectCase = resolveSelectCase(token, values);
                        var nestedTokens = evaluateToInternalValue(selectCase.tokens, language, values, components, currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "octothorpe": {
                        if (currentValue == null) {
                            throw new Error("unexpected #");
                        }
                        output.push(currentValue);
                        break;
                    }
                    default: {
                        throw new Error("unexpected type: " + token.type);
                        break;
                    }
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (tokens_1_1 && !tokens_1_1.done && (_a = tokens_1.return)) _a.call(tokens_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return output;
}
function isReactInternalValue(v) {
    return (typeof v === "object" &&
        v.hasOwnProperty("__kind") &&
        v.__kind === "react");
}
function isReactValue(v) {
    return (typeof v === "object" &&
        v.hasOwnProperty("__kind") &&
        v.__kind === "react");
}
function flatten(intervalValues) {
    var e_3, _a;
    var output = [];
    try {
        for (var intervalValues_1 = __values(intervalValues), intervalValues_1_1 = intervalValues_1.next(); !intervalValues_1_1.done; intervalValues_1_1 = intervalValues_1.next()) {
            var v = intervalValues_1_1.value;
            if (Array.isArray(v)) {
                output.push.apply(output, __spread(flatten(v)));
            }
            else if (isReactInternalValue(v)) {
                var props = v.props;
                for (var key in props) {
                    if (props.hasOwnProperty(key)) {
                        props[key] = flatten(props[key]);
                    }
                }
                output.push(v);
            }
            else {
                output.push(v);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (intervalValues_1_1 && !intervalValues_1_1.done && (_a = intervalValues_1.return)) _a.call(intervalValues_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return output;
}
function collapseValues(values) {
    var shouldCollapseToString = values.every(function (v) { return typeof v === "string"; });
    if (shouldCollapseToString) {
        return values.map(String).join("");
    }
    var shouldCollapseToSingleValue = values.length === 1;
    if (shouldCollapseToSingleValue) {
        return values[0];
    }
    return values;
}
function toOutputValues(values) {
    var e_4, _a;
    var output = [];
    try {
        for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
            var v = values_1_1.value;
            if (typeof v === "string") {
                output.push(v);
            }
            else if (typeof v === "number") {
                output.push(String(v));
            }
            else if (isReactValue(v)) {
                var propsExcludingChildren = {};
                var children = void 0;
                var component = v.type, props = v.props;
                for (var key in props) {
                    if (props.hasOwnProperty(key)) {
                        var value = collapseValues(toOutputValues(props[key]));
                        if (key === "children") {
                            children = value;
                        }
                        else {
                            propsExcludingChildren[key] = value;
                        }
                    }
                }
                if (children == null) {
                    output.push(React.createElement(component, propsExcludingChildren));
                }
                else if (Array.isArray(children)) {
                    output.push(React.createElement.apply(React, __spread([component, propsExcludingChildren], children)));
                }
                else {
                    output.push(React.createElement(component, propsExcludingChildren, children));
                }
            }
            else {
                output.push(v);
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return output;
}
function evaluate(tokens, language, values, components) {
    var internalValues = evaluateToInternalValue(tokens, language, values, components, undefined);
    return toOutputValues(flatten(internalValues));
}

function localeToLanguage(locale) {
    locale = locale.toLowerCase();
    locale = locale.replace("_", "-");
    var parts = locale.split("-");
    if (parts.length > 0) {
        return parts[0];
    }
    return "";
}

var defaultValue = {
    locale: "en",
    language: "en",
    compile: function () { return []; },
    renderToString: function () { return ""; },
};
var Context = React.createContext(defaultValue);
var Provider = Context.Provider, Consumer = Context.Consumer;
var LocaleProvider = /** @class */ (function (_super) {
    __extends(LocaleProvider, _super);
    function LocaleProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tokensByID = {};
        _this.state = {
            version: 0,
        };
        _this.compile = function (id) {
            var _a;
            var cachedTokens = _this.tokensByID[id];
            if (cachedTokens != null) {
                return cachedTokens;
            }
            var source = _this.props.messageByID[id];
            if (source == null) {
                throw new Error("expected \"" + id + "\" to exist");
            }
            try {
                var tokens = parse(source);
                _this.tokensByID = __assign({}, _this.tokensByID, (_a = {}, _a[id] = tokens, _a));
                return tokens;
            }
            catch (e) {
                var message = e.message;
                e.message = "\"" + id + "\": " + message;
                throw e;
            }
        };
        _this.renderToString = function (id, values) {
            var e_1, _a;
            try {
                var locale = _this.props.locale;
                var tokens = _this.compile(id);
                var language = localeToLanguage(locale);
                var result = evaluate(tokens, language, values || {}, {});
                var output = [];
                try {
                    for (var result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                        var a = result_1_1.value;
                        if (typeof a !== "string") {
                            throw new Error("unexpected non-string value \"" + id + "\"");
                        }
                        output.push(a);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (result_1_1 && !result_1_1.done && (_a = result_1.return)) _a.call(result_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return output.join("");
            }
            catch (e) {
                {
                    return "";
                }
                throw e;
            }
        };
        return _this;
    }
    LocaleProvider.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.locale !== prevProps.locale) {
            this.tokensByID = {};
            this.setState(function (prevState) {
                return {
                    version: prevState.version + 1,
                };
            });
        }
    };
    LocaleProvider.prototype.render = function () {
        var _a = this.props, locale = _a.locale, children = _a.children;
        return (React.createElement(Provider, { value: {
                locale: locale,
                language: localeToLanguage(locale),
                compile: this.compile,
                renderToString: this.renderToString,
            } }, children));
    };
    return LocaleProvider;
}(React.Component));
function Message(props) {
    try {
        var id = props.id, values = props.values, components = props.components, language = props.language, compile = props.compile;
        var tokens = compile(id);
        var result = evaluate(tokens, language, values || {}, components || {});
        var children = [];
        for (var i = 0; i < result.length; ++i) {
            var element = result[i];
            children.push(React.createElement(React.Fragment, { key: i }, element));
        }
        return React.createElement(React.Fragment, null, children);
    }
    catch (e) {
        {
            return "";
        }
        throw e;
    }
}
var FormattedMessage = /** @class */ (function (_super) {
    __extends(FormattedMessage, _super);
    function FormattedMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMessage = function (contextValue) {
            return React.createElement(Message, __assign({}, _this.props, contextValue));
        };
        return _this;
    }
    FormattedMessage.prototype.render = function () {
        return React.createElement(Consumer, null, this.renderMessage);
    };
    return FormattedMessage;
}(React.Component));

exports.Consumer = Consumer;
exports.Context = Context;
exports.FormattedMessage = FormattedMessage;
exports.LocaleProvider = LocaleProvider;
exports.evaluate = evaluate;
exports.parse = parse;
